import { render, staticRenderFns } from "./province.vue?vue&type=template&id=70a488d3&scoped=true"
import script from "./province.vue?vue&type=script&lang=js"
export * from "./province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a488d3",
  null
  
)

export default component.exports